import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useFormAskFeedbackStore = defineStore('formAskFeedback', () => {
  const getDefaultState = () => ({
    rating: 3,
    comment: '',
    actualStep: 1,
    nbStep: 3,
    feedbackSent: false,
    progressBarHidden: false,
    checkboxArchive: true,
  });

  const rating = ref(3);
  const comment = ref('');
  const actualStep = ref(1);
  const nbStep = ref(3);
  const feedbackSent = ref(false);
  const progressBarHidden = ref(false);
  const checkboxArchive = ref(true);

  const resetValue = () => {
    const defaults = getDefaultState();
    rating.value = defaults.rating;
    comment.value = defaults.comment;
    actualStep.value = defaults.actualStep;
    nbStep.value = defaults.nbStep;
    feedbackSent.value = defaults.feedbackSent;
    progressBarHidden.value = defaults.progressBarHidden;
    checkboxArchive.value = defaults.checkboxArchive;
  };

  const changeActualStep = (step) => {
    actualStep.value = step;
  };

  const updateRating = (newValue) => {
    rating.value = newValue;
  };

  const updateComment = (newValue) => {
    comment.value = newValue;
  };

  const changeNbStep = (newValue) => {
    nbStep.value = newValue;
  };

  const updateFeedbackSent = (value) => {
    feedbackSent.value = value;
  };

  const updateProgressBarHidden = (value) => {
    progressBarHidden.value = value;
  };

  const updateCheckboxArchive = (value) => {
    checkboxArchive.value = value;
  };

  return {
    rating,
    comment,
    actualStep,
    nbStep,
    feedbackSent,
    progressBarHidden,
    checkboxArchive,
    resetValue,
    changeActualStep,
    updateRating,
    updateComment,
    changeNbStep,
    updateFeedbackSent,
    updateProgressBarHidden,
    updateCheckboxArchive,
  };
});
